import React from 'react'
import { Route } from 'react-router-dom'
import NautaConfigurations from '../../../../components/NautaView'

const NautaConfigurationsRoutes = ({ match }) => (
  <div>
    <Route path={match.path} component={NautaConfigurations} />
  </div>
)

export default NautaConfigurationsRoutes